import type { AnimationProperties, AnimationsKit } from '../../types';

const name = 'BaseDimensions';
const properties: Partial<AnimationProperties> = {};

function animate(
  kit: AnimationsKit,
  elements: HTMLElement[] | HTMLElement | HTMLCollection,
  duration: number = 0,
  delay: number = 0,
  params: any = {},
) {
  return kit.engine.tween(elements, { duration, delay, ...params }, [
    'width',
    'height',
    'top',
    'left',
    'maxWidth',
    'maxHeight',
    'minWidth',
    'minHeight',
    'bottom',
    'right',
    'margin',
    'padding',
    'marginTop',
    'marginBottom',
    'marginLeft',
    'marginRight',
    'paddingTop',
    'paddingBottom',
    'paddingRight',
    'paddingLeft',
    'zIndex',
  ]);
}

export { name, properties, animate };
